/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendTaxSpecialDto } from '../../models/backend-tax-special-dto';

export interface ProjectTaxesTaxSpecialRetrieve$Params {
  id: number;
}

export function projectTaxesTaxSpecialRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxSpecialRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxSpecialDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxSpecialRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxSpecialDto>;
    }),
  );
}

projectTaxesTaxSpecialRetrieve.PATH = '/api/project_taxes/tax_special/{id}/';
